module.exports = __webpack_public_path__ + "static/media/Empty_state_ Savings.c27d6476.svg";